import React from 'react';

interface TipBoxProps {
  label?: string;
  children: React.ReactNode;
}

export default function TipBox({ label = 'TIP:', children }: TipBoxProps) {
  return (
    <div className="bg-[#C7EDEF] rounded-lg p-4 flex flex-col gap-2">
      <span
        className="text-xs font-black uppercase text-[#323B46]"
        style={{ fontFamily: 'DM Sans', letterSpacing: '0.72px' }}
      >
        {label}
      </span>
      <p
        className="text-base text-[#1B2831]"
        style={{ fontFamily: 'DM Sans' }}
      >
        {children}
      </p>
    </div>
  );
}
